import { render } from "./choose-plan.vue?vue&type=template&id=314a7b08"
import script from "./choose-plan.vue?vue&type=script&lang=js"
export * from "./choose-plan.vue?vue&type=script&lang=js"

import "./choose-plan.vue?vue&type=style&index=0&id=314a7b08&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__